var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16667 1C1.52233 1 1 1.52233 1 2.16667V9.16667C1 9.811 1.52233 10.3333 2.16667 10.3333H6.17185C6.0504 10.1519 5.94822 9.95648 5.86823 9.75H4.5V8H5.74101C5.78708 7.79696 5.85374 7.60175 5.93869 7.41667H4.5V5.66667H6.83333V6.29185C7.01273 6.15315 7.20828 6.03433 7.41667 5.93869V5.66667H9.75V5.86823C9.95648 5.94822 10.1519 6.0504 10.3333 6.17185V2.16667C10.3333 1.52233 9.811 1 9.16667 1H2.16667ZM7.41667 3.33333H9.75V5.08333H7.41667V3.33333ZM3.91667 8V9.75H2.16667C1.8445 9.75 1.58333 9.48883 1.58333 9.16667V8H3.91667ZM3.91667 7.41667H1.58333V5.66667H3.91667V7.41667ZM3.91667 5.08333H1.58333V3.33333H3.91667V5.08333ZM4.5 5.08333V3.33333H6.83333V5.08333H4.5Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 11C9.95533 11 11 9.95533 11 8.66667C11 7.378 9.95533 6.33333 8.66667 6.33333C7.378 6.33333 6.33333 7.378 6.33333 8.66667C6.33333 9.95533 7.378 11 8.66667 11ZM8.91667 7.66667C8.91667 7.5286 8.80474 7.41667 8.66667 7.41667C8.5286 7.41667 8.41667 7.5286 8.41667 7.66667V8.41667H7.66667C7.5286 8.41667 7.41667 8.5286 7.41667 8.66667C7.41667 8.80474 7.5286 8.91667 7.66667 8.91667H8.41667V9.66667C8.41667 9.80474 8.5286 9.91667 8.66667 9.91667C8.80474 9.91667 8.91667 9.80474 8.91667 9.66667V8.91667H9.66667C9.80474 8.91667 9.91667 8.80474 9.91667 8.66667C9.91667 8.5286 9.80474 8.41667 9.66667 8.41667H8.91667V7.66667Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHeaderIcon);
export default __webpack_public_path__ + "static/media/tableHeaderIcon.f780eb7fc0a9cda9fbb89c47de79fd0d.svg";
export { ForwardRef as ReactComponent };